module.exports = __webpack_public_path__ + "static/media/burst.40edca09.mp4";